import { Alert, Button } from 'antd';
import { localMobile } from '../../../../../shared/policies/local-mobile';
import { ConfirmItsYouPanel } from '../../../components/ConfirmItsYouPanel';
import { useContactChange } from '../hooks/use-contact-change';
import type { ContactKind } from '../policies/contact-change';
import { ContactCodeForm } from './ContactCodeForm';
import { NewContactForm } from './NewContactForm';
import { ProfileRow } from './ProfileRow';

interface ContactRowProps {
  kind: ContactKind;
  label: string;
  /** The current email or mobile; null when there's no mobile yet. */
  current: string | null;
}

function display(kind: ContactKind, value: string): string {
  return kind === 'phone' ? localMobile(value) : value;
}

/** The email or mobile, with the change flow opening under it. */
export function ContactRow({ kind, label, current }: ContactRowProps) {
  const change = useContactChange(kind);
  const { state, error, submitting, confirmation } = change;
  const isConfirming = confirmation.state.phase === 'code';

  return (
    <ProfileRow
      label={label}
      value={current ? display(kind, current) : <span className="text-muted">None. Add one to get sign-in codes on your phone.</span>}
      action={
        state.phase === 'idle' && (
          <Button size="small" onClick={change.open}>
            {current ? 'Change' : 'Add'}
          </Button>
        )
      }
    >
      <ConfirmItsYouPanel confirmation={confirmation} />
      {state.phase !== 'idle' && !isConfirming && (
        <div className="mt-3 max-w-sm">
          {error && <Alert className="mb-3" type="error" title={error} showIcon />}
          {state.phase === 'new' && <NewContactForm kind={kind} submitting={submitting} onSend={change.sendCode} onCancel={change.close} />}
          {state.phase === 'code' && (
            <ContactCodeForm
              destination={display(kind, state.value)}
              displayedCode={state.displayedCode}
              submitting={submitting}
              onVerify={change.verify}
              onResend={change.resend}
              onCancel={change.close}
            />
          )}
        </div>
      )}
    </ProfileRow>
  );
}
